import React from 'react'
import './loader.css'

function Loader() {
  return (
    <div>
      <div className="loader"></div>
    </div>
  )
}

export default Loader
